import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FaWhatsapp } from 'react-icons/fa'
import { HiX } from 'react-icons/hi'

export default function WhatsAppButton({ number, number2, name1, name2 }) {
  const [isOpen, setIsOpen] = useState(false)
  const whatsappNumber1 = number || import.meta.env.VITE_WHATSAPP_NUMBER || ''
  const whatsappNumber2 = number2 || ''
  
  const displayLabel1 = name1 || 'מאיה'
  const displayLabel2 = name2 || 'הילה'

  if (!whatsappNumber1 && !whatsappNumber2) return null

  const message = encodeURIComponent('היי, אשמח לשמוע פרטים על הסדנה הקרובה')
  const url1 = whatsappNumber1 ? `https://wa.me/${whatsappNumber1}?text=${message}` : ''
  const url2 = whatsappNumber2 ? `https://wa.me/${whatsappNumber2}?text=${message}` : ''

  const isDouble = whatsappNumber1 && whatsappNumber2

  if (!isDouble) {
    const singleUrl = url1 || url2
    return (
      <motion.a
        href={singleUrl}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="fixed bottom-6 left-6 z-50 bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-colors"
        aria-label="WhatsApp"
      >
        <FaWhatsapp size={28} />
      </motion.a>
    )
  }

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col items-center gap-4">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            className="flex flex-col gap-3"
          >
            <a
              href={url2}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-green-600 px-5 py-3 rounded-full shadow-xl font-bold border border-green-100 flex items-center justify-between gap-3 hover:bg-green-50 transition-colors min-w-[120px]"
            >
              <span>{displayLabel2}</span> <FaWhatsapp size={20} />
            </a>
            <a
              href={url1}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-green-600 px-5 py-3 rounded-full shadow-xl font-bold border border-green-100 flex items-center justify-between gap-3 hover:bg-green-50 transition-colors min-w-[120px]"
            >
              <span>{displayLabel1}</span> <FaWhatsapp size={20} />
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-colors text-white ${isOpen ? 'bg-gray-800 hover:bg-gray-900' : 'bg-green-500 hover:bg-green-600'}`}
        aria-label="WhatsApp options"
      >
        {isOpen ? <HiX size={24} /> : <FaWhatsapp size={28} />}
      </motion.button>
    </div>
  )
}
